<div class="container-fluid pt-3 pb-4 py-sm-5 px-sm-5">
  <div>
    <div class="py-2 py-sm-4 d-flex">
      <h1 class="d-inline-block align-middle me-3 contact-us-icon-container">
        <img class="contact-us-icon" src="assets/icons/icon-contact-us.svg" alt="" />
      </h1>
      <h1 class="d-inline-block align-middle m-0" data-test-id="contact-us-title">
        {{ 'CONTACT_US_TITLE' | translate }}
      </h1>
    </div>
    <div class="row justify-content-center" *ngIf="formContent && isAuthenticated">
      <div data-test-id="contact-us-form" class="col-md-10 col-lg-9 col-xl-8">
        <app-form-constructor [formContent]="formContent"></app-form-constructor>
        <div class="d-flex flex-column">
          <small class="form-text text-muted required-hint" data-test-id="small-required">
            * - {{ 'REQUIRED_FIELD_HINT' | translate }}
          </small>
          <button
            class="btn btn-primary width"
            type="submit"
            data-test-id="btn-send-msg"
            (click)="sendMessage($event)"
            [disabled]="isDisabledSubmitButton"
          >
            {{ 'CONTACT_US_SEND_MSG_BTN_HINT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="contact-us-not-logged-in-title" *ngIf="formContent && !isAuthenticated">
    <h2 class="d-block align-middle m-0" data-test-id="contact-us-not-logged-in">
      {{ 'CONTACT_US_NOT_LOGGED_IN_MESSAGE' | translate }}
    </h2>
    <h2 class="d-block align-middle m-0 mail-color" data-test-id="contact-us-email-not-logged-in">
      <a [href]="'mailto:' + contactMail">
        {{ contactMail }}
      </a>
    </h2>
  </div>
  <div *ngIf="!formContent">
    <div class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner">
      <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
    </div>
  </div>
</div>
